import { render, staticRenderFns } from "./page4Mobile.vue?vue&type=template&id=b754145a&scoped=true&"
import script from "./page4Mobile.vue?vue&type=script&lang=js&"
export * from "./page4Mobile.vue?vue&type=script&lang=js&"
import style0 from "./page4Mobile.vue?vue&type=style&index=0&id=b754145a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b754145a",
  null
  
)

export default component.exports